import { useSelector } from "react-redux";

/**
 * Custom hook to retrieve medical report settings and template info
 * Centralizes the template check (standard vs chai format) and business information
 */
const useMedicalReportSettings = (
  defaultTemplate = "standard_medical_report",
) => {
  const auth = useSelector((state) => state?.auth);

  const medicalReportSettings =
    auth?.medicalReportSettings ||
    auth?.user?.settings?.invoice_size?.medical_report_settings ||
    {};

  const activeTemplate = medicalReportSettings?.template || defaultTemplate;

  const isChaiFormat = activeTemplate === "medical_report_chai_format";

  const businessInfo =
    auth?.buisnessInfo || auth?.businessInfo || auth?.user?.business || {};

  return {
    isChaiFormat,
    activeTemplate,
    medicalReportSettings,
    businessInfo,
    buisnessInfo: businessInfo,
    auth,
  };
};

export default useMedicalReportSettings;
